import {
    apiRequest,
    mappingKelasPegawaiDetail, 
    mappingKelasPegawaiUpdate,
} from "../../../../../services/adapters/kepegawaian/mappingKelasPegawaiService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", mappingKelasPegawaiDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", mappingKelasPegawaiUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository